import type { NavigationGuard } from 'vue-router';
import useApalumaAnalytics from '@/composables/analytics/use-apaluma-analytics.ts';
import { useAuthStore } from '@/stores/auth-store.ts';
import { storeToRefs } from 'pinia';

/**
 * Router middleware for auth guard
 */
export const apalumaAnalytics: NavigationGuard = () => {
   const { isAuthenticated } = storeToRefs(useAuthStore());
   const { sendUserActivity } = useApalumaAnalytics();

   if (isAuthenticated.value) {
      sendUserActivity();
   }
};
